<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-expenses
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @filtering="onFilter"
          @download-excel="onDownloadExcel"
          v-if="isTopManager"
        ></filter-expenses>
        <table-paginated-expenses
          :is-component-loading="isRequestingNow"
          :paginated-object="paginatedObject"
          :results-object="resultsObject"
          :result="result"
          :allTotals="allTotals"
        ></table-paginated-expenses>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
/* constants */
import { DATE_ISO } from '@/constants/dates';
/* proxy */
import ExpensesProxy from '@/proxies/Cashier/ExpensesProxy';
/* mixins */
import accountMixin from '@/mixins/accountMixin';
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import downloadReport from '@/mixins/reports/downloadReport';
import expenseListing from '@/mixins/cashier/expenseListing';
/* components */
import TablePaginatedExpenses from '@/components/listings/TablePaginatedExpenses.vue';
import FilterExpenses from '@/components/listings/FilterExpenses.vue';


export default {
  name: 'Expenses',
  mixins: [
    accountMixin,
    updatePageContentMixin,
    defaultListingMixin,
    downloadReport,
    expenseListing,
  ],
  components: {
    TablePaginatedExpenses,
    FilterExpenses,
  },
  data() {
    return {
      reportMethodName: 'expenseListingReport',
      searchParams: {
        search_recipient: '',
        search_manager: null,
        search_expense_category: null,
        from: null,
        to: null,
      },
      paginatedObject: {},
      resultsObject: {},
      result: 0.00,
      allTotals: {},
    };
  },
  created() {
    this.searchParams.search_recipient = null;
    this.searchParams.search_manager = null;
    this.searchParams.search_expense_category = null;
    this.searchParams.order_to = 'desc';
    this.searchParams.from = moment()
      .startOf('day')
      .format(DATE_ISO);
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      // console.log(this.searchParams);
      new ExpensesProxy()
        .setParameters(this.searchParams)
        .all()
        .then(response => {
          this.paginatedObject = response.data.data.expenses;
          this.resultsObject = response.data.data.results;
          this.result = response.data.data.total;
          this.allTotals = response.data.data.allTotals;

          this.$forceUpdate();
          console.log(response.data.data);
        })
        .catch(error => {
          console.warn(error);
          this.paginatedObject = {};
          this.result = null;
          this.allTotals = null;
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
  },
};
</script>
